"use client";
// This component should only be in production

import { useEffect, useState } from "react";

import { LinkButton } from "@/components/links/LinkButton";

export function CookieSettingsButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const updateVisibility = () => {
      const cb = window.Cookiebot;
      // Show button only for in-region users once Cookiebot knows country
      if (
        cb === undefined ||
        cb.userCountry === undefined ||
        cb.userCountry === "" ||
        cb.isOutOfRegion === undefined
      ) {
        return;
      }
      setIsVisible(!cb.isOutOfRegion);
    };

    // Run once in case Cookiebot already loaded
    updateVisibility();

    window.addEventListener("CookiebotOnLoad", updateVisibility);
    window.addEventListener("CookiebotOnAccept", updateVisibility);
    window.addEventListener("CookiebotOnDecline", updateVisibility);

    return () => {
      window.removeEventListener("CookiebotOnLoad", updateVisibility);
      window.removeEventListener("CookiebotOnAccept", updateVisibility);
      window.removeEventListener("CookiebotOnDecline", updateVisibility);
    };
  }, []);

  const openCookieSettings = () => {
    const cb = window.Cookiebot;

    try {
      if (cb !== undefined && cb.show !== undefined) {
        cb.show();
        return;
      }

      console.error("Cookiebot UI not found");
    } catch (error) {
      console.error("Error while opening Cookiebot settings:", error);
    }
  };

  if (!isVisible) {
    return null;
  }

  return (
    <LinkButton
      onClick={openCookieSettings}
      className="pb-12 text-sm font-normal text-gray-600 hover:text-gray-900 xl:ml-6 xl:pb-6"
    >
      Cookie Settings
    </LinkButton>
  );
}
